import { useRef } from "react";
import { Link } from "react-router-dom";
import { useRooms } from "@/data/rooms";
import { MaskLines, Reveal } from "@/components/MaskLines";
import { useLang } from "@/lib/i18n";

const XS = [11, 29, 43, 57, 72, 88];

export const Overhead = () => {
  const { t } = useLang();
  const rooms = useRooms();
  const box = useRef(null);
  const onMove = (e) => {
    const r = box.current.getBoundingClientRect();
    box.current.style.setProperty("--x", `${e.clientX - r.left}px`);
    box.current.style.setProperty("--y", `${e.clientY - r.top}px`);
  };
  return (
    <section className="py-24" data-testid="overhead-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <p className="mono text-xs text-[var(--brick-light)]">{t("over.kicker")}</p>
        <MaskLines inView className="mt-4 font-display text-5xl leading-[0.95] lg:text-7xl" lines={[t("over.l1"), <em key="c">{t("over.l2")}</em>]} />
        <p className="mono mt-6 text-[11px] text-[var(--muted)] md:hidden">{t("over.swipe")}</p>
      </div>
      <Reveal className="mt-10 overflow-x-auto px-5 md:px-10" >
        <div
          ref={box}
          onMouseMove={onMove}
          className="relative mx-auto min-w-[900px] max-w-[1440px] overflow-hidden rounded-2xl"
          style={{ "--x": "50%", "--y": "50%" }}
          data-lenis-prevent
        >
          <img src="/img/topdown.webp" alt={t("over.alt")} className="block w-full" />
          <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(circle 320px at var(--x) var(--y), transparent 0%, rgba(13,12,10,0.72) 100%)" }} />
          {rooms.map((r, i) => (
            <Link key={r.id} to={`/explorar?sala=${r.id}`} className="pin absolute -translate-x-1/2" style={{ left: `${XS[i]}%`, top: "62%", "--c": r.color }} data-testid={`overhead-pin-${r.id}`}>
              <span className="pin-dot" /> {r.name}
            </Link>
          ))}
        </div>
      </Reveal>
    </section>
  );
};

export const FinalCta = () => {
  const { t } = useLang();
  return (
  <section className="mx-auto max-w-[1440px] px-5 pb-28 pt-10 md:px-10" data-testid="final-cta">
    <Reveal>
      <Link to="/explorar?mode=3d" className="group relative mx-auto block max-w-4xl overflow-hidden rounded-t-full border border-white/15 bg-[var(--card)] px-6 pb-16 pt-28 text-center md:pt-40" data-testid="final-cta-link">
        <span className="absolute inset-0 origin-bottom scale-y-0 bg-[var(--brick)] transition-transform duration-700 ease-[cubic-bezier(.16,1,.3,1)] group-hover:scale-y-100" />
        <span className="relative mono text-xs text-[var(--muted)] group-hover:text-[var(--ink)]">{t("cta.kicker")}</span>
        <span className="relative mt-4 block font-display text-6xl leading-none md:text-8xl">{t("cta.l1")} <em>{t("cta.l2")}</em></span>
        <span className="relative mt-8 inline-flex rounded-full border border-white/30 px-6 py-3 text-sm">{t("cta.btn")}</span>
      </Link>
    </Reveal>
  </section>
  );
};
